import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from '../assets/substitution-btn.module.scss';

const CreateSubstitutionButton: React.FunctionComponent = () => (
    <div className={classNames('py-4', 'text-right w-100', styles.btn)}>
        <Link to={Router.generate(routes.SUBSTITUTION_CREATE)} className={`${'btn btn-success'}`}>
            <span>Create</span>
        </Link>
    </div>
);

export default CreateSubstitutionButton;
